'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRole$002dName$0024$0024anon$002487 from "./presto.types$-Role-Name$$anon$87.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RoleName$() {
  this.c9b = null;
  this.c9c = false;
  this.c9f = null;
  this.c9g = false;
  this.c9d = null;
  this.c9e = false;
}
export { $c_Lpresto_types$RoleName$ as $c_Lpresto_types$RoleName$ };
$p = $c_Lpresto_types$RoleName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RoleName$;
/** @constructor */
function $h_Lpresto_types$RoleName$() {
}
export { $h_Lpresto_types$RoleName$ as $h_Lpresto_types$RoleName$ };
$h_Lpresto_types$RoleName$.prototype = $p;
$p.nM = (function() {
  if ((!this.c9c)) {
    this.c9b = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c9c = true;
  }
  return this.c9b;
});
$p.cIU = (function() {
  if ((!this.c9g)) {
    this.c9f = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.c9g = true;
  }
  return this.c9f;
});
$p.csf = (function() {
  if ((!this.c9e)) {
    this.c9d = new $j_presto$002etypes$0024$002dRole$002dName$0024$0024anon$002487.$c_Lpresto_types$RoleName$$anon$87(this);
    this.c9e = true;
  }
  return this.c9d;
});
var $d_Lpresto_types$RoleName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RoleName$, "presto.types$RoleName$", ({
  a14: 1,
  D: 1
}));
export { $d_Lpresto_types$RoleName$ as $d_Lpresto_types$RoleName$ };
var $n_Lpresto_types$RoleName$;
function $m_Lpresto_types$RoleName$() {
  if ((!$n_Lpresto_types$RoleName$)) {
    $n_Lpresto_types$RoleName$ = new $c_Lpresto_types$RoleName$();
  }
  return $n_Lpresto_types$RoleName$;
}
export { $m_Lpresto_types$RoleName$ as $m_Lpresto_types$RoleName$ };
//# sourceMappingURL=presto.types$-Role-Name$.js.map
